import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
    Router,
    browserHistory,
    createMemoryHistory,
} from 'react-router';
import { Provider } from 'react-redux';
import { syncHistoryWithStore } from 'react-router-redux';

import configureStore from '../store/configureStore';
import UrlGenerator from '../lib/UrlGenerator';

const DevTools = __DEV__ ? require('./DevTools').default : null;

const propTypes = {
    url: PropTypes.string,
    urlGenerator: PropTypes.instanceOf(UrlGenerator),
    routerRoutes: PropTypes.object,
    renderProps: PropTypes.object,
    pages: PropTypes.array,
    menu: PropTypes.array,
};

const defaultProps = {
    url: null,
    urlGenerator: null,
    renderProps: null,
    routerRoutes: null,
    pages: [],
    menu: [],
};

const childContextTypes = {
    urlGenerator: PropTypes.object,
    socket: PropTypes.object,
};

class Root extends Component {

    constructor(props) {
        super(props);

        const routerHistory = typeof window === 'undefined' ?
            createMemoryHistory({
                initialEntries: props.url !== null ? [props.url] : [],
            }) : browserHistory;

        this.store = configureStore({
            test: 'hello!',
            site: {
                menu: props.menu,
                pages: props.pages,
            },
        });

        this.history = syncHistoryWithStore(
            routerHistory,
            this.store,
        );
    }

    getChildContext() {
        return {
            urlGenerator: this.props.urlGenerator,
        };
    }

    render() {
        const { routerRoutes, renderProps } = this.props;

        const routerProps = typeof window === 'undefined' || renderProps !== null ? {
            ...renderProps,
        } : {
            history: this.history,
            routes: routerRoutes,
        };
        const router = (
            <Router
                {...routerProps}
            />
        );

        const root = __DEV__ ? (
            <Provider store={this.store}>
                <div>
                    { router }
                    <DevTools />
                </div>
            </Provider>
        ) : (
            <Provider store={this.store}>
                { router }
            </Provider>
        );

        return root;
    }
}

Root.propTypes = propTypes;
Root.defaultProps = defaultProps;
Root.childContextTypes = childContextTypes;

export default Root;



// WEBPACK FOOTER //
// ./components/Root.jsx